import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import lodash from 'lodash';

// import { clearMemoizedWorkflow } from '../../utils/network';
import { parseQueryString } from '../../utils/utils'
import useTranslation from '../../hooks/use-translation';
import useLoader from '../../hooks/use-loader';
import apiRequest from '../../utils/api.request';
// import InputForm from '../VaccinationDetails/VaccinationDetailsWrapper/Components/InputForm';
import UpdateVaccineDetails from "../VaccinationSc/UpdateVaccineDetails";
import VaccinationDetailsContainer from "../VaccinationDetails/VaccinationDetailsContainer";
import ThankYouVaccinationDetails from "../VaccinationDetails/ThankYouVaccinationDetails";
import { _getErrorMessage } from '../VaccinationDetails/VaccinationDetailsWrapper/Utils/getErrorMessage';
import {
  ess, recordEssParams
} from '../OnBoarding/ess';
import { vaccinationApiRequestBody } from "../VaccinationDetails/VaccinationDetailsWrapper/Utils/vaccinationApiRequestBody";
import { isJhhIdVerified } from '../VaccinationCertificate/Utils/isJhhIdVerified';
import config from "../../config.json";

import VaccinationScWrapper from '../VaccinationSc';
import './VaccinationInfo.css'

let auth_token;
let source_id;
let source_user_id;
let source_relation;
let source_user_relation_id;

const VaccinationInfo = () => {
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);
  const params = parseQueryString();
  const { t, language } = useTranslation();
  const userInfoFromParams = useRef();
  const [pageLoadError, setPageLoadError] = useState();
  const [vaccineOptions, _setVaccineOptions] = useState();
  const [userVaccineDose1Info, _setUserVaccineDose1Info] = useState();
  const [userVaccineDose2Info, _setUserVaccineDose2Info] = useState();
  const [showVaccineDetails, _setShowVaccineDetails] = useState(false);
  const [showEditDetails, _setShowEditDetails] = useState(false);
  const [showAddDetailsForDose, _setShowAddDetailsForDose] = useState(false);
  const [vaccinated, _setVaccinated] = useState(false);
  const [showAddDetailsButton, _setShowAddDetailsButton] = useState(false);
  const [showAddDetailsDoseButton, _setShowAddDetailsDoseButton] = useState(false);
  const [showThankYou, _setShowThankYou] = useState(false);
  const [showVaccinationSc, _setShowVaccinationSc] = useState(false);
  const [doseNo, _setDoseNo] = useState(1);
  const { showLoading, hideLoading, loadingCount } = useLoader();
  const user_details = useRef();
  const eoiSscParams = useRef();
  const name = atob(params.t);

  const getUserVaccinationStatus = async (params) => {
    const url = config.covid_vacc_base_url + "v1/get-user-covid-info/";
    source_id = lodash.get(params, "source_id");
    switch (source_id) {
      case "emp_xp": {
        auth_token = lodash.get(params, "auth_token");
        source_user_id = lodash.get(params, "source_user_id");
        source_relation = lodash.get(params, "source_relation");
        source_user_relation_id = lodash.get(params, "source_user_relation_id");
        if (!auth_token || !source_user_id || !source_relation || (source_user_relation_id == undefined)) {
          return;
        }
        else {
          user_details.current = {
            auth_token,
            source_id,
            source_user_id,
            source_relation,
            source_user_relation_id
          };
          const dataObj = vaccinationApiRequestBody({}, user_details.current);
          const response = await apiRequest(url, dataObj, true);
          if (lodash.get(response, "status") !== "success") {
            setPageLoadError(lodash.get(response, "response.data.message", "Something went wrong, please try again"))
          } else {
            return response;
          }
        }
        break;
      }
      case "JioHealthHub": {
        auth_token = lodash.get(params, "auth_token");
        source_user_id = lodash.get(params, "source_user_id");
        if (!auth_token || !source_user_id) {
          return;
        }
        else {
          user_details.current = {
            auth_token,
            source_id: source_id.toLowerCase(),
            jhh_id: source_user_id,
          };
          const dataObj = vaccinationApiRequestBody({ jhh_id: source_user_id }, user_details.current);
          const response = await apiRequest(url, dataObj, true, false, false, false, false, false, false, false, true);
          if (lodash.get(response, "status") !== "success") {
            setPageLoadError(lodash.get(response, "response.data.message", "Something went wrong, please try again"))
          } else {
            return response;
          }
        }
        break;
      }
      default: {
        return;
      }
    }
  }

  const getUserInfoFromParams = (params) => {
    if (ess().isFromEss) {
      return {
        relation: ess().eventData.source_relation,
        gender: ess().eventData.source_gender,
        age: parseInt(ess().eventData.source_age_years, 10)
      };
    }
    else if (params.source_id === "JioHealthHub") {
      return {
        relation: params.relation,
        gender: params.gender,
        age: parseInt(params.age, 10),
      };
    }

    else if (params.source_id === "MyJio") {
      return {
        relation: params.source_relation,
        gender: params.source_gender,
        age: parseInt(params.source_age_years, 10),
      };
    }
    return {};
  };

  const _getJhhIdInfo = async () => {
    const auth_token = lodash.get(params, "auth_token");
    const source_id = lodash.get(params, "source_id").toLowerCase();
    const source_user_id = lodash.get(params, "source_user_id");
    const source_relation = lodash.get(params, "source_relation");
    const source_user_relation_id = lodash.get(params, "source_user_relation_id");
    if (!auth_token || !source_id || !source_user_id || !source_relation || (source_user_relation_id == undefined)) {
      return false;
    }
    const userDetailsObj = {
      auth_token,
      source_id,
      source_user_id,
      source_relation,
      source_user_relation_id
    };
    showLoading();
    let response;
    try {
      response = await isJhhIdVerified(userDetailsObj);
      hideLoading();
    } catch (error) {
      setPageLoadError(lodash.get(error, "message", "Something went wrong. Please try again."));
      hideLoading();
      return false
    }
    if (lodash.get(response, "status") !== "success") {
      setPageLoadError(lodash.get(response, "response.data.message", "Something went wrong. Please try again."));
      return false;
    }
    if (lodash.get(response, "validated") == "no") {
      history.push(`/vaccination-info/verifyjhhid?${urlParams.toString()}`)
      return false;
    }
    return true;
  }

  const _getVaccineOptions = async () => {
    const getVaccineOptionsURL = config.covid_vacc_base_url + "v1/get-covid-vaccine-list/";
    const response = await apiRequest(getVaccineOptionsURL);
    if (lodash.get(response, "status") !== "success") {
      // setPageLoadError(lodash.get(response,"response.data.message","Something went wrong. Please try again."));
      return;
    }
    let newVaccineOptions = lodash.get(response, "data", []);
    newVaccineOptions.unshift({ name: "", display_name: "Select" });
    _setVaccineOptions(newVaccineOptions);
    // _setShowEditDetails(true);
  }

  const _getEoiSscParams = async () => {
    if (eoiSscParams.current !== undefined) {
      return eoiSscParams.current;
    }
    const getEoiSscParamsURL = config.covid_vacc_base_url + "v1/get-eoi-ssc-param/";
    const response = await apiRequest(getEoiSscParamsURL);
    if (lodash.get(response, "status") !== "success") {
      setPageLoadError(lodash.get(response, "response.data.message", "Something went wrong. Please try again."));
      return;
    }
    eoiSscParams.current = response;
    return response;
  }


  const _flowEngine = async () => {
    source_id = lodash.get(params, "source_id").toLowerCase();
    showLoading()
    getUserVaccinationStatus(params).then(async (response) => {
      hideLoading();
      if (response) {
        _setShowVaccineDetails(true);
        const vaccinated = lodash.get(response, "vaccinated", false);
        await _getVaccineOptions()
        if (vaccinated) {
          _setVaccinated(true);
          const vaccineDetailsDose1 = lodash.find(lodash.get(response, "vaccine.vaccines", []), { "dose": "1" });
          const vaccineDetailsDose2 = lodash.find(lodash.get(response, "vaccine.vaccines", []), { "dose": "2" });
          _setUserVaccineDose1Info(vaccineDetailsDose1);
          _setUserVaccineDose2Info(vaccineDetailsDose2);
          _checkAge(vaccinated);
        } else {
          _setVaccinated(false);
          _checkAge();
        }
      }
    })
  }

  const _checkAge = async (vaccinatedArg) => {
    const getJhhidInfo = lodash.get(params, "get_jhhid_info", "").toLowerCase() === "false" ? false : true;
    source_id = lodash.get(params, "source_id").toLowerCase();
    if (source_id === "emp_xp" && getJhhidInfo) {
      const proceedForward = await _getJhhIdInfo();
      if (!proceedForward) {
        return;
      }
    }
    userInfoFromParams.current = getUserInfoFromParams(params);
    if (userInfoFromParams.current && userInfoFromParams.current.relation) {
      let ageBelowLimit = false;
      showLoading();
      const response = await _getEoiSscParams();
      hideLoading();
      const sscAgeLimit = lodash.get(response, "data.ssc_min_age");
      if (sscAgeLimit != undefined && userInfoFromParams.current.age < sscAgeLimit) {
        ageBelowLimit = true;
      }
      if (ageBelowLimit) {
        _setShowAddDetailsButton(false)
        _setShowVaccineDetails(true);
      }
      else {
        if (vaccinatedArg) {
          _setShowAddDetailsDoseButton(true);
        }
        else
          _setShowAddDetailsButton(true);
        _setShowVaccineDetails(true);
      }
    }
  }

  useEffect(() => {
    recordEssParams();
    _flowEngine();
  }, [])

  const _buttonClickHandler = (doseNumber, doseVaccinatedValue) => {
    if (showAddDetailsButton) {
      _setShowVaccinationSc(true); //Add click
    } else if (vaccinated) {
      if (doseVaccinatedValue) {
        _setShowEditDetails(true); //Edit click
        _setShowAddDetailsForDose(false); //Edit click
        _setDoseNo(doseNumber);
      }
      else {
        _setShowEditDetails(false); //Edit click
        _setShowAddDetailsForDose(true); //Add for dose click
        _setDoseNo(doseNumber);
      }
    }
  }

  if (pageLoadError) {
    return (<div className="vaccination-sc-page-load-error">{_getErrorMessage(pageLoadError)}</div>)
  }

  return (
    <div className={`vaccination-sc-wrapper padding-top-very-small`}>
      <div className="vaccination-sc-title vaccination-details-info-title margin-bottom-none">{t("VACCINATION_DETAILS")}</div>
      {showVaccineDetails && vaccinated &&
        <>
          <VaccinationDetailsContainer name={name} userVaccineInfo={userVaccineDose1Info} hideButton={!showAddDetailsDoseButton} vaccinated={vaccinated} buttonOnclickhandler={(doseNumber, doseVaccinatedValue) => { _buttonClickHandler(doseNumber, doseVaccinatedValue) }} doseNumberFromProps={"1"} hideNameSentence={false} doseNo={doseNo} addOrEditClicked={showAddDetailsForDose || showEditDetails} />
          <hr />
          <VaccinationDetailsContainer name={name} userVaccineInfo={userVaccineDose2Info} hideButton={!showAddDetailsDoseButton} vaccinated={vaccinated} buttonOnclickhandler={(doseNumber, doseVaccinatedValue) => { _buttonClickHandler(doseNumber, doseVaccinatedValue) }} hideNameSentence={true} doseNumberFromProps={"2"} doseNo={doseNo} addOrEditClicked={showAddDetailsForDose || showEditDetails} />
        </>
      }
      {showVaccineDetails && !vaccinated &&
        <VaccinationDetailsContainer name={name} userVaccineInfo={userVaccineDose1Info} hideButton={!showAddDetailsButton} vaccinated={vaccinated} buttonOnclickhandler={() => { _buttonClickHandler(showAddDetailsButton, vaccinated) }} addClicked={showVaccinationSc} />
      }
      {showVaccinationSc &&
        <>
          <hr />
          <VaccinationScWrapper hideHeader={true} handleCompleteFinish={() => { _setShowVaccineDetails(false); _setShowVaccinationSc(false); _setShowThankYou(true) }} />
        </>
      }
      <div>
        {showEditDetails &&
          <UpdateVaccineDetails
            hideQuestion={true}
            doseNo={doseNo}
            vaccine_select_options={vaccineOptions}
            params={params}
            _onSubmitFinish={() => { _setShowVaccineDetails(false); _setShowEditDetails(false); _setShowAddDetailsForDose(false); _setShowThankYou(true); }}
          />
        }
        {showAddDetailsForDose &&
          <UpdateVaccineDetails
            question={`${t('HI')}${name ? (` ${name}, ${t('ARE_YOU')}`) : `, ${t('ARE_YOU')}`} ${t('VACCINATION_QUESTION')} ${doseNo}?`}
            params={params}
            doseNo={doseNo}
            vaccine_select_options={vaccineOptions}
            _onSubmitFinish={() => { _setShowVaccineDetails(false); _setShowEditDetails(false); _setShowAddDetailsForDose(false); _setShowThankYou(true) }}
            _handleNoClick={() => { _setShowVaccineDetails(false); _setShowEditDetails(false); _setShowAddDetailsForDose(false); _setShowThankYou(true) }}
            _afterYesClick={() => { }}
            showUpperHr={true}
          />
        }
      </div>
      <br />
      {showThankYou &&
        <ThankYouVaccinationDetails t={t} />
      }
    </div>
  )
}

export default VaccinationInfo;
